export default "__VITE_ASSET__9iW7yLwI__"